import React from "react";
import LegalLayout, { LegalSection, LegalSub, LegalList, LegalCallout, Field } from "../../components/LegalLayout";
import SEO from "../../components/SEO";
import { COMPANY } from "../../config/COMPANY-INFO";

export default function PrivacyPage() {
  return (
    <>
      <SEO
        title="Ochrana osobních údajů"
        description="Zásady ochrany osobních údajů (GDPR) společnosti Apex Detailing — jak zpracováváme vaše data při rezervaci detailingu vozu."
        path="/pravni/ochrana-osobnich-udaju"
      />
      <LegalLayout
      title="Zásady ochrany osobních údajů"
      subtitle="Jak Apex Detailing zpracovává vaše osobní údaje v souladu s GDPR (Nařízení EU 2016/679) a českým zákonem č. 110/2019 Sb."
      testId="page-privacy"
    >
      <LegalSection id="spravce" title="1. Správce osobních údajů">
        <p>Správcem vašich osobních údajů je:</p>
        <LegalList>
          <li>Jméno / Obchodní firma: <Field value={COMPANY.legalName} name="jméno správce" /></li>
          <li>IČO: <Field value={COMPANY.ico} name="IČO" /></li>
          <li>Sídlo / místo podnikání: <strong>{COMPANY.address.full}</strong></li>
          <li>E-mail: <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a></li>
          <li>Telefon: <a href={`tel:${COMPANY.contact.phoneRaw}`} className="text-apex-gold hover:underline">{COMPANY.contact.phone}</a></li>
        </LegalList>
        <p>Pověřence pro ochranu osobních údajů (DPO) nejmenujeme — naše zpracování nesplňuje podmínky pro jeho povinné jmenování dle čl. 37 GDPR.</p>
      </LegalSection>

      <LegalSection id="udaje" title="2. Jaké údaje zpracováváme a proč">
        <LegalSub title="2.1 Rezervace služby">
          <p>Při vytvoření rezervace zpracováváme tyto údaje:</p>
          <LegalList>
            <li><strong>Identifikační údaje:</strong> jméno, příjmení</li>
            <li><strong>Kontaktní údaje:</strong> e-mail, telefon</li>
            <li><strong>Údaje o vozidle:</strong> značka, model, typ (osobní/SUV/VAN)</li>
            <li><strong>Údaje o místě plnění:</strong> v případě mobilní služby adresa, kde má být služba provedena</li>
            <li><strong>Údaje o platbě:</strong> způsob platby, stav platby, ID platební transakce u Stripe (samotné údaje o platební kartě my neuchováváme — viz oddíl 4)</li>
            <li><strong>Poznámky:</strong> jakékoliv informace, které sami uvedete ke své rezervaci</li>
          </LegalList>
          <p><strong>Účel:</strong> uzavření a plnění smlouvy o poskytnutí služby (čl. 6 odst. 1 písm. b) GDPR).</p>
          <p><strong>Doba uchování:</strong> 5 let od konce účetního období, kterého se týkají (§ 31 zákona č. 563/1991 Sb., o účetnictví); u daňových dokladů po dobu stanovenou daňovými předpisy.</p>
        </LegalSub>

        <LegalSub title="2.2 Uživatelský účet">
          <p>Při registraci uživatelského účtu navíc zpracováváme heslo (uložené v zašifrované formě pomocí algoritmu bcrypt — v plaintextu jej nikdy neukládáme).</p>
          <p><strong>Účel:</strong> autentizace zákazníka pro správu vlastních rezervací (čl. 6 odst. 1 písm. b) GDPR — plnění smlouvy).</p>
          <p><strong>Doba uchování:</strong> dokud účet neodstraníte (lze požádat na e-mailu výše).</p>
        </LegalSub>

        <LegalSub title="2.3 Komunikace e-mailem">
          <p>E-mailové potvrzení, schválení, připomínka platby, poděkování po službě — jsou nezbytnou součástí poskytování služby a jsou odesílány přes externí službu Brevo (viz oddíl 4).</p>
          <p><strong>Účel:</strong> plnění smlouvy (čl. 6 odst. 1 písm. b) GDPR).</p>
        </LegalSub>

        <LegalSub title="2.4 Marketingová komunikace">
          <p>Po dokončení služby vám můžeme zaslat jednorázový věrnostní slevový kód a poděkování. Pro pravidelný newsletter nebo marketingové nabídky bychom si vyžádali váš zvláštní souhlas — v současnosti newsletter neprovozujeme.</p>
        </LegalSub>

        <LegalSub title="2.5 Cookies a měřicí nástroje">
          <p>
            Web ukládá technicky nezbytné údaje v localStorage prohlížeče (přihlašovací token, předvolby zobrazení). Dále web používá měřicí značku <strong>Google Ads (Google Tag)</strong> pro vyhodnocení účinnosti reklamních kampaní — sleduje, zda návštěva webu vedla k odeslání rezervace. Tato značka se načte pouze tehdy, pokud k tomu udělíte souhlas v cookie liště. Souhlas můžete kdykoliv změnit nebo odvolat v nastavení cookies v patičce webu. Podrobnosti najdete na samostatné{" "}
            <a href="/pravni/cookies" className="text-apex-gold hover:underline">stránce Cookies</a>.
          </p>
          <p><strong>Účel:</strong> měření účinnosti reklamy (čl. 6 odst. 1 písm. a) GDPR — souhlas).</p>
        </LegalSub>

        <LegalSub title="2.6 Fotodokumentace vozidla">
          <p>Před zahájením a po dokončení služby pořizujeme fotografie vozidla.</p>
          <p><strong>Účel a právní základ:</strong> doložení stavu vozidla při předání a ochrana obou stran při případné reklamaci (čl. 6 odst. 1 písm. f) GDPR — oprávněný zájem).</p>
          <p><strong>Doba uchování:</strong> 12 měsíců od poskytnutí služby.</p>
          <p><strong>Zveřejnění v galerii:</strong> fotografie použijeme na webu, sociálních sítích nebo v reklamě pouze s vaším souhlasem, o který vás požádáme zvlášť (čl. 6 odst. 1 písm. a) GDPR). Souhlas můžete kdykoliv odvolat a fotografie odstraníme. Před zveřejněním vždy znečitelníme registrační značku vozidla.</p>
        </LegalSub>
      </LegalSection>

      <LegalSection id="prava" title="3. Vaše práva jako subjekt údajů">
        <p>Dle GDPR máte ve vztahu k vašim osobním údajům následující práva. Pro uplatnění kteréhokoliv z nich nám napište na{" "}
          <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a>. Vyhrazujeme si právo ověřit vaši totožnost.
        </p>
        <LegalList>
          <li><strong>Právo na přístup</strong> — kdykoliv se nás můžete zeptat, jaké údaje o vás zpracováváme.</li>
          <li><strong>Právo na opravu</strong> — pokud jsou údaje nepřesné nebo neúplné.</li>
          <li><strong>Právo na výmaz („právo být zapomenut“)</strong> — v určitých případech, např. odvolání souhlasu nebo zánik účelu zpracování.</li>
          <li><strong>Právo na omezení zpracování</strong> — žádost o pozastavení dalšího zpracování po dobu vyřízení námitky.</li>
          <li><strong>Právo vznést námitku</strong> — proti zpracování opřenému o oprávněný zájem.</li>
          <li><strong>Právo na přenositelnost</strong> — strukturované, strojově čitelné vydání údajů, které jste nám poskytli.</li>
          <li><strong>Právo odvolat souhlas</strong> — pokud je zpracování založeno na souhlasu (např. budoucí newsletter).</li>
          <li>
            <strong>Právo podat stížnost</strong> u dozorového úřadu —{" "}
            <a href={COMPANY.links.uoouCz} target="_blank" rel="noopener noreferrer" className="text-apex-gold hover:underline">
              Úřad pro ochranu osobních údajů (uoou.cz)
            </a>
            .
          </li>
        </LegalList>
        <p className="text-sm text-apex-cream/65">Vyřízení žádosti probíhá zpravidla do 30 dnů od jejího přijetí.</p>
      </LegalSection>

      <LegalSection id="subprocesory" title="4. Komu vaše údaje předáváme (zpracovatelé)">
        <p>K provozu rezervačního systému využíváme následující prověřené externí zpracovatele. Se všemi máme uzavřeny zpracovatelské smlouvy a všichni zpracovávají údaje v souladu s GDPR.</p>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full text-sm border-collapse" data-testid="subprocessor-table">
            <thead>
              <tr className="text-apex-gold uppercase tracking-wider text-[11px]">
                <th className="text-left py-2 pr-4 border-b border-apex-line">Zpracovatel</th>
                <th className="text-left py-2 pr-4 border-b border-apex-line">Účel</th>
                <th className="text-left py-2 border-b border-apex-line">Lokalita</th>
              </tr>
            </thead>
            <tbody>
              {COMPANY.subprocessors.map((s) => (
                <tr key={s.name} className="border-b border-apex-line/40">
                  <td className="py-3 pr-4 font-semibold text-apex-cream">{s.name}</td>
                  <td className="py-3 pr-4 text-apex-cream/75">{s.purpose}</td>
                  <td className="py-3 text-apex-cream/65">{s.country}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-sm">
          <strong>Stripe</strong> jako zpracovatel platebních údajů (PCI DSS Level 1) zpracovává údaje o platební kartě přímo na své infrastruktuře. K údajům karty nemáme přístup, ukládáme pouze jednorázový identifikátor transakce.
        </p>
        <p className="text-sm">
          Mimo tyto zpracovatele neposkytujeme údaje žádné jiné třetí straně — kromě případů, kdy nám to ukládá zákon (např. orgán daňové správy, soud).
        </p>
      </LegalSection>

      <LegalSection id="zabezpeceni" title="5. Zabezpečení">
        <p>Údaje jsou uloženy v databázi v rámci EU. Komunikace mezi prohlížečem a serverem je vždy šifrována přes HTTPS (TLS 1.2+). Hesla jsou uložena hashována pomocí algoritmu bcrypt; přihlašovací tokeny jsou opatřeny krátkou dobou platnosti.</p>
        <p>Přístup k osobním údajům má pouze provozovatel, případně spolupracující osoby v rozsahu nezbytném pro poskytnutí služby a zavázané mlčenlivostí.</p>
      </LegalSection>

      <LegalSection id="zmeny" title="6. Změny zásad">
        <p>Tyto zásady můžeme příležitostně aktualizovat (např. při přidání nového zpracovatele). Aktuální znění je vždy dostupné na této stránce s vyznačeným datem účinnosti.</p>
        <LegalCallout>
          Toto znění zásad nabývá účinnosti dnem <strong>{COMPANY.effectiveDate}</strong>.
        </LegalCallout>
      </LegalSection>
    </LegalLayout>
    </>
  );
}
